import React from 'react';
import Icon, {ICON_NAME} from "../../Icon";
import {Button} from "antd";

interface IProps {
    className?: string

    onDelete(): void
}

const ButtonDelete: React.FC<IProps> = ({className = '', onDelete}) => {
    return <Button className={`bt-ghost ${className}`} data-icon='true' data-danger={true} onClick={onDelete}>
        <Icon icon={ICON_NAME.DELETE}/>
    </Button>;
};

export default ButtonDelete;
